module.exports = __webpack_public_path__ + "media/images/black_history_month/arrow-top-4ef1ab382ba9b4dfa755a78472ac78bf.png";